import { render, staticRenderFns } from "./tag1.vue?vue&type=template&id=f515123c&scoped=true&"
import script from "./tag1.vue?vue&type=script&lang=js&"
export * from "./tag1.vue?vue&type=script&lang=js&"
import style0 from "./tag1.vue?vue&type=style&index=0&id=f515123c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f515123c",
  null
  
)

export default component.exports